// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { Component } from './component';

/**
 * @class Jsw.form.DisplayField
 * @extends Jsw.Component
 */
export const DisplayField = Class.create(Component, {
    _tag: 'div',

    _initConfiguration($super, config) {
        $super(config);
        this._cls = this._getConfigParam('cls', 'form-row');
        this._valueRenderer = this._getConfigParam('valueRenderer', null);
    },

    _initComponentElement($super) {
        $super();

        let values = ('function' === typeof this._valueRenderer)
            ? this._valueRenderer()
            : this._getConfigParam('value', '');

        values = (typeof values === 'string') ? [values] : values;

        let valuesElements = '';
        values.each(function (value) {
            valuesElements += `<div class="text-value">${value}</div>`;
        });

        if (this._getConfigParam('singleRow', false)) {
            if (1 === values.length) {
                valuesElements = values.valueOf();
            }
            this._componentElement.update(`<div class="single-row">${valuesElements}</div>`);
        } else {
            this._componentElement.update(
                `<div class="field-name">${this._getConfigParam('fieldLabel', '')}</div>` +
                `<div class="field-value">${valuesElements}</div>`
            );
        }
    },
});

/**
 * @class Jsw.form.Values
 */
export const Values = class {
    /**
     * @cfg {String} selector CSS selector
     */

    constructor(config) {
        this.selector = config.selector;
        this.formValues = {};
        $$(this.selector).each(input => {
            this.formValues[this.getStorageName(input)] = input.getValue();
        });
    }

    /**
     * @returns {Boolean}
     */
    isChanged() {
        let changed = false;
        $$(this.selector).each(input => {
            if (this.formValues[this.getStorageName(input)] != input.getValue()) {
                changed = true;
            }
        });
        return changed;
    }

    getStorageName(input) {
        return `${input.getAttribute('type')}/${input.getAttribute('name')}`;
    }
};



// WEBPACK FOOTER //
// ./jsw/form.js